// Kiddee collection content. Play styles map to the product "shop_category" field.
export const PLAY_STYLES = [
  { id: "water", label: "Water & Pool Toys", blurb: "Floaty, splashy toys for dogs who head straight for the pool.", icon: "Waves" },
  { id: "fetch", label: "Fetch & Chase", blurb: "Throw it, chase it, bring it back. Repeat.", icon: "Zap" },
  { id: "squeaky", label: "Squeaky Toys", blurb: "That squeak gets her every time.", icon: "Music" },
  { id: "interactive", label: "Interactive & Enrichment", blurb: "Treat puzzles that keep busy brains working.", icon: "Brain" },
  { id: "durable", label: "Durable Play", blurb: "Tougher rubber and nylon toys built for strong chewers.", icon: "Shield" },
];

export const KIDDEE_FAQ = [
  {
    q: "How do I pick the right toy for my dog?",
    a: "Match the toy to how your dog plays. Swimmers love the water toys, retrievers go for fetch toys, and busy brains do well with treat puzzles. Choose a toy that is too big to fit fully in your dog's mouth or be swallowed, and follow any size guidance on the product's packaging.",
  },
  {
    q: "Are these toys indestructible?",
    a: "No toy is truly indestructible. Our durable toys are made for tougher chewing, but every dog chews differently. Supervise play, check toys regularly, and replace any toy that is cracked, torn or worn down to small pieces.",
  },
  {
    q: "How do I clean them?",
    a: "Most rubber and nylon toys can be washed with warm, soapy water and rinsed well. Let water toys dry fully between swims. Follow the care instructions on the packaging when they're provided.",
  },
  {
    q: "How fast is shipping and what does it cost?",
    a: "Orders ship within 1–2 business days. Shipping is free on orders of $50 or more after discounts, and $5.99 otherwise. We currently ship within the US.",
  },
  {
    q: "What if my dog doesn't like it?",
    a: "Happy pets or your money back within 30 days. Contact us with your order number and we'll make it right. Details are on our shipping & returns page.",
  },
];

export const SAFETY_NOTE = "Supervise your dog during play. Pick a size your dog can't swallow, inspect the toy regularly, and replace it if it becomes damaged or worn.";
